import React from "react";

export const PriceSummary = ({ price, withVAT = false }) => (
  <div className="price-summary">
    <div className="price-summary__gesamt-label">
      <span>Gesamtpreis: </span>
      <span className="price-summary__vat-label">
        {withVAT ? "inkl." : "zzgl."} Pfand und MwSt.
      </span>
    </div>
    <span>{price}</span>
  </div>
);
